import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: calc(100% - 60px);
  padding: 40px 30px;
  background: #fff;
`;

export const Title = styled.p`
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: GmarketSansMedium, sans-serif;
  font-size: 22px;
`;

export const Table = styled.table`
  border-collapse: collapse;
  margin-top: 20px;
  width: 100%;

  border: 1px solid #e3e3e3;
  & > thead th {
    height: 48px;
    font-size: 11px;
    text-align: center;
    background: #fafafa;
    border-bottom: 1px solid #e3e3e3;
  }

  & > tbody > tr:not(:last-child) {
    border-bottom: 1px solid rgb(236, 239, 243);
  }
  & > tbody > tr td {
    height: 46px;
    text-align: center;
    position: relative;
  }
  & > tbody > tr td:first-child {
    width: 100px;
  }

  & > thead > tr th:nth-child(2),
  & > tbody > tr td:nth-child(2) {
    text-align: left;
    text-indent: 20px;
  }
  & > tbody > tr td > img {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
  }
`;
